import { isAxiosError } from 'axios';
import { inject, injectable } from 'inversify';
import WalletService from 'src/features/pariWallet/data/service/WalletService';
import { GetAvailableSpentTransactionsParams } from 'src/features/pariWallet/data/service/WalletService.types';
import { GetAvailableTransactionsUseCaseInterface } from 'src/features/pariWallet/domain/WalletUseCases.types';

@injectable()
class GetAvailableTransactionsUseCase
  implements GetAvailableTransactionsUseCaseInterface
{
  @inject(WalletService) private walletService!: WalletService;

  async execute({
    userUuid,
    ordering,
    filters,
    walletUuid,
    limit = 2000,
    offset,
  }: GetAvailableSpentTransactionsParams) {
    try {
      const response = await this.walletService.getAvailableTransactions({
        userUuid,
        ordering,
        filters,
        walletUuid,
        limit,
        offset,
      });

      return response.data;
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return {
          count: 0,
          next: null,
          previous: null,
          results: [],
        };
      }
      throw error;
    }
  }
}

export default GetAvailableTransactionsUseCase;
